// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e1981d7","239":"f80ea193","455":"1eb59beb"}[chunkId] + ".chunk.js";
};